'use strict';/* global define, console */define('modules/core/modules/app/services/redirect/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$rootScope", "$state", "$location"];
function factory($rootScope,$state,$location){// jshint validthis:true
// jshint latedef:false
var _redirectOnGoing=false;/**
     * Redirect to the provided valid state
     *
     * Note: Currently there is no error handler implemented
     * for invalid states passed to this function
     *
     * @param  {String}           state   - State name
     * @param  {Object|undefined} options - Options object
     * @return {Object}                   - Redirect state object
     */function redirectTo(state,options){options=options||{};var path=$location.path();if(!_redirectOnGoing){var redirectCheck=$rootScope.$on('$stateChangeSuccess',function(){_redirectOnGoing=false;redirectCheck();});_redirectOnGoing=true;if(path!=='/'&&options.includePath){return $state.go(state,{url:path.replace(/\//g,'_')});}$state.go(state);}}return{redirectTo:redirectTo};}module.exports=factory;});
